import { GET_INTERVIEW } from "graphql/queries";
import { useQueryData } from "hooks";

/**
 * useInterview
 *
 * @param {String}   uuid
 */
export default function useInterview({ uuid }) {
  const { data, loading, error } = useQueryData({
    queryName: GET_INTERVIEW,
    keyName: "interview",
    variables: {
      uuid,
    },
    skip: !uuid,
  });

  return { data: data?.interview, loading, error };
}
